// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingForm-needFormCardFlex-yjKsl {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 6px;
    grid-gap: 6px;
    padding: 18px;
    border: 1px solid var(--primary-border);
    border-radius: var(--radius-2);
}

.BookingForm-needFormCardImgContainer-MxCAk {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
        -ms-flex-align: baseline;
            align-items: baseline;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    grid-gap: 6px;
    width: 100%;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    text-align: start;
}

.BookingForm-needFormCardImgContainer-MxCAk img {
    position: relative;
    top: 3px;
}

.BookingForm-needFormCardContainer-NWjjQ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 18px;
    grid-gap: 18px;
}

/* Date/time picker clock button (Book Now — both flows). This class lived only in
   ScheduleBookingForm.css, so BookingForm's \`s.scheduleClockBtn\` resolved to undefined and the button
   rendered as a default oversized Bootstrap button. Mirror the ScheduleBookingForm styling so it's the
   small red icon button attached to the right of the date input. */

.BookingForm-scheduleClockBtn-xtkGg {
    -ms-flex-negative: 0;
        flex-shrink: 0;
    height: 44px;
    border: 1px solid var(--primary-bg) !important;
    background: var(--primary-bg) !important;
    border-radius: 0 var(--radius-1) var(--radius-1) 0;
    padding: 11px 12px !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.BookingForm-scheduleClockBtn-xtkGg img {
    width: 22px;
    height: 22px;
}

/* Quick date/time preset chips (app parity: Tomorrow AM/PM/eve, In 2 days). One-tap pills sitting
   above the calendar; the calendar stays for custom picks. */

.BookingForm-slotChipRow-hTX8w {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 14px;
}

.BookingForm-slotChip-pGSNK {
    padding: 8px 14px;
    border-radius: 20px;
    border: 1px solid var(--primary-bg);
    background: #fff;
    background: var(--card, #fff);
    color: var(--primary-bg);
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    cursor: pointer;
    -webkit-transition: background 0.15s ease, color 0.15s ease;
    transition: background 0.15s ease, color 0.15s ease;
}

.BookingForm-slotChip-pGSNK:hover {
    background: rgba(225, 29, 42, 0.08);
}

.BookingForm-slotChipActive-TnYnv {
    background: var(--primary-bg);
    color: #fff;
    color: var(--primary-foreground-on-brand, #fff);
}
`, "",{"version":3,"sources":["webpack://./src/components/BookingForm/BookingForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,aAAa;IACb,uCAAuC;IACvC,8BAA8B;AAClC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,2BAAqB;QAArB,wBAAqB;YAArB,qBAAqB;IACrB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,WAAW;IACX,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,cAAc;AAClB;;AAEA;;;mEAGmE;;AACnE;IACI,oBAAc;QAAd,cAAc;IACd,YAAY;IACZ,8CAA8C;IAC9C,wCAAwC;IACxC,kDAAkD;IAClD,6BAA6B;IAC7B,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AACA;6DAC6D;;AAC7D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAe;QAAf,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mCAAmC;IACnC,gBAA6B;IAA7B,6BAA6B;IAC7B,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,2DAAmD;IAAnD,mDAAmD;AACvD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,WAA+C;IAA/C,+CAA+C;AACnD","sourcesContent":[".needFormCardFlex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 6px;\n    grid-gap: 6px;\n    padding: 18px;\n    border: 1px solid var(--primary-border);\n    border-radius: var(--radius-2);\n}\n\n.needFormCardImgContainer {\n    display: flex;\n    align-items: baseline;\n    justify-content: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    width: 100%;\n    flex-grow: 1;\n    text-align: start;\n}\n\n.needFormCardImgContainer img {\n    position: relative;\n    top: 3px;\n}\n\n.needFormCardContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n/* Date/time picker clock button (Book Now — both flows). This class lived only in\n   ScheduleBookingForm.css, so BookingForm's `s.scheduleClockBtn` resolved to undefined and the button\n   rendered as a default oversized Bootstrap button. Mirror the ScheduleBookingForm styling so it's the\n   small red icon button attached to the right of the date input. */\n.scheduleClockBtn {\n    flex-shrink: 0;\n    height: 44px;\n    border: 1px solid var(--primary-bg) !important;\n    background: var(--primary-bg) !important;\n    border-radius: 0 var(--radius-1) var(--radius-1) 0;\n    padding: 11px 12px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.scheduleClockBtn img {\n    width: 22px;\n    height: 22px;\n}\n/* Quick date/time preset chips (app parity: Tomorrow AM/PM/eve, In 2 days). One-tap pills sitting\n   above the calendar; the calendar stays for custom picks. */\n.slotChipRow {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 14px;\n}\n\n.slotChip {\n    padding: 8px 14px;\n    border-radius: 20px;\n    border: 1px solid var(--primary-bg);\n    background: var(--card, #fff);\n    color: var(--primary-bg);\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 18px;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.slotChip:hover {\n    background: rgba(225, 29, 42, 0.08);\n}\n\n.slotChipActive {\n    background: var(--primary-bg);\n    color: var(--primary-foreground-on-brand, #fff);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"needFormCardFlex": `BookingForm-needFormCardFlex-yjKsl`,
	"needFormCardImgContainer": `BookingForm-needFormCardImgContainer-MxCAk`,
	"needFormCardContainer": `BookingForm-needFormCardContainer-NWjjQ`,
	"scheduleClockBtn": `BookingForm-scheduleClockBtn-xtkGg`,
	"slotChipRow": `BookingForm-slotChipRow-hTX8w`,
	"slotChip": `BookingForm-slotChip-pGSNK`,
	"slotChipActive": `BookingForm-slotChipActive-TnYnv`
};
module.exports = ___CSS_LOADER_EXPORT___;
